import { debounce } from 'lodash';
import { useState, useEffect } from 'react';

// Custom hook to determine if the device is desktop or mobile based on window width.
export const useDeviceType = () => {
  // Helper function to get the current window width, with a fallback for SSR.
  const getWidth = () => (typeof window !== 'undefined' ? window.innerWidth : 1024);

  // State to store the current window width.
  const [width, setWidth] = useState(getWidth);

  useEffect(() => {
    // Debounced handler to update width state on window resize.
    const handleResize = debounce(() => setWidth(window.innerWidth), 100);

    // Add event listener for window resize.
    window.addEventListener('resize', handleResize);
    // Cleanup event listener on unmount.
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Determine if the device is desktop or mobile based on width.
  const isDesktop = width >= 768;
  const isMobile = width < 768;

  // Return device type booleans.
  return { isDesktop, isMobile };
};
